(function () {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseRating(value) {
    var rating = Number(value);
    if (!Number.isFinite(rating)) {
      return 5;
    }
    return Math.max(1, Math.min(5, Math.round(rating)));
  }

  function buildStars(rating) {
    return new Array(parseRating(rating) + 1).join('★');
  }

  function buildCard(review, sourceUrl) {
    var text = normalizeText(review.text);
    var author = normalizeText(review.author);
    var relativeTime = normalizeText(review.relativeTime);
    var rating = parseRating(review.rating);
    var cardSourceUrl = normalizeText(review.sourceUrl) || sourceUrl;

    return [
      '<div class="chaukhat-testimonials__card" role="listitem">',
      '  <div class="chaukhat-testimonials__quote-mark">"</div>',
      '  <div class="chaukhat-testimonials__stars" aria-label="' + rating + ' out of 5 stars">' + buildStars(rating) + '</div>',
      '  <p class="chaukhat-testimonials__review">"' + escapeHtml(text) + '"</p>',
      '  <hr class="chaukhat-testimonials__divider-hr">',
      author ? '  <p class="chaukhat-testimonials__name">— ' + escapeHtml(author) + '</p>' : '',
      relativeTime ? '  <p class="chaukhat-testimonials__meta">' + escapeHtml(relativeTime) + '</p>' : '',
      cardSourceUrl ? '  <a class="chaukhat-testimonials__link" href="' + escapeHtml(cardSourceUrl) + '" target="_blank" rel="noopener">View on Google</a>' : '',
      '</div>',
    ].join('');
  }

  function extractFallbackReviews(track) {
    return Array.prototype.map.call(
      track.querySelectorAll('.chaukhat-testimonials__card'),
      function (card) {
        var stars = normalizeText(
          card.querySelector('.chaukhat-testimonials__stars') && card.querySelector('.chaukhat-testimonials__stars').textContent
        );
        var reviewText = normalizeText(
          card.querySelector('.chaukhat-testimonials__review') && card.querySelector('.chaukhat-testimonials__review').textContent
        ).replace(/^["“]|["”]$/g, '');
        var author = normalizeText(
          card.querySelector('.chaukhat-testimonials__name') && card.querySelector('.chaukhat-testimonials__name').textContent
        ).replace(/^[-—]\s*/, '');
        var meta = normalizeText(
          card.querySelector('.chaukhat-testimonials__meta') && card.querySelector('.chaukhat-testimonials__meta').textContent
        );

        return {
          rating: (stars.match(/★/g) || []).length || 5,
          text: reviewText,
          author: author,
          relativeTime: meta,
        };
      }
    ).filter(function (review) {
      return normalizeText(review.text);
    });
  }

  function renderTrack(track, reviews, sourceUrl) {
    var normalizedReviews = reviews.filter(function (review) {
      return normalizeText(review && review.text);
    });

    if (!normalizedReviews.length) {
      return;
    }

    var cardsMarkup = normalizedReviews.map(function (review) {
      return buildCard(review, sourceUrl);
    }).join('');

    var copies = normalizedReviews.length >= 3 ? 2 : normalizedReviews.length === 2 ? 3 : 5;
    track.innerHTML = new Array(copies + 1).join(cardsMarkup);
    track.classList.add('is-ready');
    track.classList.toggle('is-animated', normalizedReviews.length > 1);
    track.style.setProperty('--google-review-duration', Math.max(24, normalizedReviews.length * 8) + 's');
  }

  async function loadReviews(section) {
    var track = section.querySelector('[data-google-reviews-track]');
    if (!track) {
      return;
    }

    var feedUrl = section.getAttribute('data-feed-url');
    var sourceUrl = section.getAttribute('data-source-url') || '';
    var reviews = extractFallbackReviews(track);

    if (feedUrl) {
      try {
        var response = await fetch(feedUrl, { credentials: 'same-origin' });
        if (response.ok) {
          var payload = await response.json();
          if (payload && Array.isArray(payload.reviews) && payload.reviews.length) {
            reviews = payload.reviews;
          }
        }
      } catch (error) {
        console.warn('Google reviews feed fetch failed.', error);
      }
    }

    renderTrack(track, reviews, sourceUrl);
  }

  function initGoogleReviewsMarquee() {
    var sections = document.querySelectorAll('[data-google-reviews-marquee]');
    Array.prototype.forEach.call(sections, function (section) {
      loadReviews(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGoogleReviewsMarquee);
  } else {
    initGoogleReviewsMarquee();
  }
})();
